// extracted by mini-css-extract-plugin
export default {"ac-richtext":"_4E9hDL59Y4oAkP7HPxt"};